import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { SKU_MANAGEMENT_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { clearSkuManagementSignals } from "./@signals"
import { useSkuManagement } from "./@hooks"
import SkuManagementFilters from "./Filters"
import SkuManagementTable from "./Table"


export default function SkuManagementPage() {
    // Initialize hook to handle data fetching
    useSkuManagement()

    useEffect(() => {
        return clearSkuManagementSignals
    }, [])

    return <PageWrapper
        head={SKU_MANAGEMENT_ROUTES.TITLE}
        title={SKU_MANAGEMENT_ROUTES.TITLE}
        subtitle={SKU_MANAGEMENT_ROUTES.SUBTITLE}
        actions={null}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <SkuManagementFilters />
            </Grid>

            <Grid item xs={12}>
                <SkuManagementTable />
            </Grid>
        </Grid>
    </PageWrapper>
}
